export default "__VITE_ASSET__klRkG6wu__"